import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueCookies from 'vue-cookies'
import Vuelidate from 'vuelidate'

import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(Vuelidate)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
